import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { CheckCircle } from 'lucide-react';
import AuthLayout from './components/auth/AuthLayout';
import AuthCard from './components/auth/AuthCard';

function ResetSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/login'), 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <AuthLayout>
        <AuthCard>
          <div className="auth-status-icon success">
            <CheckCircle className="w-10 h-10 text-[var(--color-text-primary)]" />
          </div>
          <h2 className="text-2xl font-bold text-[var(--color-text-primary)] mb-2">Password updated</h2>
          <p className="text-[var(--color-text-secondary)]">Your password was successfully changed.</p>
          <p className="text-[var(--color-text-muted)] text-sm mt-2">Redirecting to sign in...</p>
        </AuthCard>
    </AuthLayout>
  );
}

export default ResetSuccess;
